export default "__VITE_ASSET__Dh7Iy1cj__"